import { render, staticRenderFns } from "./cModalUser.vue?vue&type=template&id=e770c978&lang=es"
import script from "./cModalUser.vue?vue&type=script&lang=js"
export * from "./cModalUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports